import React from 'react';
import { ProductAttributePathSettings, conditionTypeSettingsToSelectOptions } from '../../../common/FieldFilters';

import {
    Select,
    Stack,
    Autocomplete,
} from '@shopify/polaris';

function FieldFilterComponent(props) {

    function updateSelection(selected) {
        if (selected.length === 0) {
            props.onConditionValueChange(null);
        }
        else {
            props.onConditionValueChange(selected[0]);
        }
    }

    function getMatchingOptions(value) {

        let newMatchingValueOptions = props.distinctValues.map(_ => distinctToOption(_));

        if (value !== '' && value != null) {

            const filterRegex = new RegExp(value, 'i');
            newMatchingValueOptions = props.distinctValues.filter((option) =>
                option != null && option.match(filterRegex),
            ).map(_ => distinctToOption(_));
        }

        return newMatchingValueOptions;
    };

    function distinctToOption(distinctValue) {

        return {
            "value": distinctValue,
            "label": distinctValue
        }
    }

    function createValueInput() {

        if (props.comparison === "HasValue" || props.comparison === "HasNoValue") {
            return null;
        }

        // var attributeType = ProductAttributePathSettings[props.fieldPath];
        var textField = (
            <Autocomplete.TextField
                onChange={props.onValueChange}
                value={props.value}
                placeholder="Choose value"
            />
        );

        let conditionValue = props.value;
        if (conditionValue != null) {
            conditionValue = conditionValue.toString();
        }

        const matchingOptions = getMatchingOptions(props.value);

        return <Autocomplete
            options={matchingOptions}
            selected={[]}
            onSelect={updateSelection}
            textField={textField}
        />
    }

    var typeSettings = ProductAttributePathSettings[props.fieldPath];
    var options = conditionTypeSettingsToSelectOptions(
        typeSettings.dataType,
        false);

    return (
        <Stack alignment="center" spacing="tight">
            <Select
                options={options}
                value={props.comparison}
                onChange={props.onComparisonChange}
            />
            {createValueInput()}
        </Stack>
    );
}

FieldFilterComponent.defaultProps = {
    distinctValues: []
}

export default FieldFilterComponent;